export const EVALUATION_VERDICTS = {
  CORRECT: "CORRECT",
  INCORRECT: "INCORRECT", 
  PARTIALLY_CORRECT: "PARTIALLY_CORRECT",
  UNATTEMPTED: "UNATTEMPTED"
} as const;

export type EvaluationVerdict = "CORRECT" | "INCORRECT" | "PARTIALLY_CORRECT" | "UNATTEMPTED";

export const EVALUATION_VERDICT_LABELS = {
  [EVALUATION_VERDICTS.CORRECT]: "Correct",
  [EVALUATION_VERDICTS.INCORRECT]: "Incorrect", 
  [EVALUATION_VERDICTS.PARTIALLY_CORRECT]: "Partially Correct",
  [EVALUATION_VERDICTS.UNATTEMPTED]: "Unattempted"
} as const;

export const EVALUATION_VERDICT_OPTIONS = [
  { value: EVALUATION_VERDICTS.UNATTEMPTED, label: EVALUATION_VERDICT_LABELS[EVALUATION_VERDICTS.UNATTEMPTED] },
  { value: EVALUATION_VERDICTS.CORRECT, label: EVALUATION_VERDICT_LABELS[EVALUATION_VERDICTS.CORRECT] },
  { value: EVALUATION_VERDICTS.INCORRECT, label: EVALUATION_VERDICT_LABELS[EVALUATION_VERDICTS.INCORRECT] },
  { value: EVALUATION_VERDICTS.PARTIALLY_CORRECT, label: EVALUATION_VERDICT_LABELS[EVALUATION_VERDICTS.PARTIALLY_CORRECT] }
];

export const EVALUATION_TYPES ={
  QUESTION_WISE_EVALUATION:"QUESTION_WISE_EVALUATION",
  EXAM_SUBMISSION_WISE_EVALUATION:"EXAM_SUBMISSION_WISE_EVALUATION"
}